// Shared checks for the "Add Applypa to Chrome" prompts (the one-time modal in
// App.vue and the nudge on Upwork/JobStreet jobs in QuickApplySidebar).
//
// The server decides the feature flag, dismiss count and snooze
// (user.show_extension_prompt / user.extension_prompt_enabled); this file covers
// what only the browser knows: can this browser install a Chrome extension, and
// is ours already here.

import { EXTENSION_STORE_URL, detectExtension } from '@/services/extensionBridge';

export { EXTENSION_STORE_URL };

// Desktop Chromium browsers install from the Chrome Web Store (Chrome, Edge,
// Brave, Opera, Arc). Phones, tablets, Safari and Firefox can't.
export function canInstallExtensionHere() {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const uaData = navigator.userAgentData;
  if (uaData?.mobile) return false;
  if (/Android|iPhone|iPad|iPod|Mobile|CriOS|FxiOS/i.test(ua)) return false;
  if (window.innerWidth < 768) return false;
  const isChromium = uaData?.brands
    ? uaData.brands.some((b) => /Chromium|Google Chrome|Microsoft Edge/i.test(b.brand))
    : /Chrome\/|Edg\//.test(ua) && !/Firefox\//.test(ua);
  return isChromium;
}

// One check per page load: 'ready' | 'outdated' | 'missing'.
let detection = null;
export function extensionStatus() {
  if (!detection) detection = detectExtension().catch(() => 'missing');
  return detection;
}

// A prompt dismissed with × in this tab stays hidden until the tab closes.
const SESSION_KEY = 'applypa_extension_nudge_hidden';
export function nudgeHiddenThisSession() {
  try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; }
}
export function hideNudgeThisSession() {
  try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) { /* storage blocked */ }
}
